import '../../common/bn-property';
import { LitEntity, html } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';

class WorkOrderLocationDetails extends LitEntity {
  static get styles() {
    return sharedStyles;
  }

  render() {
    const { latitude, longitude } = this.getProperty('location', {});
    if (!latitude || !longitude) {
      return html``;
    }
    const mapsHref = `https://www.google.com/maps/dir/?api=1&travelmode=driving&dir_action=navigate&destination=${latitude},${longitude}`;
    return html`
      <span class="map-links">
        <a href="geo:${latitude},${longitude}">${latitude},${longitude}</a>
        <span class="divider">|</span>
        <a target="_blank" href="${mapsHref}">
          Google Maps
          <bn-icon name="far fa-external-link"></bn-icon>
        </a>
      </span>
    `;
  }
}

customElements.define('work-order-location-details', WorkOrderLocationDetails);
